// API endpoints
export const ENDPOINTS = {
  // Public content endpoints
  CONTENT: {
    LIST: '/content',
    DETAIL: (id) => `/content/${id}`,
    SEARCH: '/content/search',
  },
  
  // Public categories
  CATEGORIES: {
    LIST: '/categories',
    DETAIL: (id) => `/categories/${id}`,
  },
  
  // Public comments
  COMMENTS: {
    LIST: (contentId) => `/content/${contentId}/comments`,
    ADD: (contentId) => `/content/${contentId}/comments`,
  },
  
  // Blog endpoints
  BLOGS: {
    PROMINENT: '/blogs/prominent',
  },
  
  // Game reviews endpoints
  GAME_REVIEWS: {
    RECENTLY: '/game-reviews/recently',
    LATEST: '/game-reviews/latest',
  },
  
  // Game reviews endpoints
  APP_REVIEWS: {
    RECENTLY: '/app-reviews/recently',
    LATEST: '/app-reviews/latest',
  },
  
  // Image endpoint
  IMAGES: {
    // THUMBNAIL: (path) => `http://192.168.110.28:8445/publish/files/image?thumbnailPath=${path}`,
    THUMBNAIL: (path) => `https://api.gamelim.com/publish/files/image?thumbnailPath=${path}`,
  },
}; 